import { render, staticRenderFns } from "./NewQuestionComponent.vue?vue&type=template&id=35d9df14&"
import script from "./NewQuestionComponent.vue?vue&type=script&lang=js&"
export * from "./NewQuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewQuestionComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports